import React from "react";
import ReactDOM from "react-dom/client";
import { Theme } from "config/styles/Theme";
import { GlobalStyles } from "@mui/material";
import { globalStyles } from "config/styles/GlobalStyle";
import { Helmet } from "react-helmet";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import PageRoot from "./pages/PageRoot";
import "styles.css";
import "react-toastify/dist/ReactToastify.css";

const appGlobalStyles = <GlobalStyles styles={globalStyles} />;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Helmet title="Atix Operator" />
      <Theme>
        {appGlobalStyles}
        <PageRoot />
      </Theme>
    </PersistGate>
  </Provider>,
);
